<template>
  <div class="mypage-card member-card">
    <div class="mypage-card-header">
      <h3>eラーニング決済情報の確認</h3>
    </div>
    <div class="mypage-card-body">
      <a id="customer-portal-link" @click="redirectToStripe()">決済管理画面へ移動する(Stripe)</a>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    props: [
      'stripeCustomerId'
    ],

    data () {
      return {
        customerId: this.stripeCustomerId,
      }
    },

    methods: {
      redirectToStripe () {
        const res = axios.get('/api/create-customer-portal-session', {
          params: {
            customerId: this.customerId
          }
        }).then(async res => {
          const data = res.data

          if (res.status !== 200 || !data || data.error) {
            return false
          }

          window.location.href = data.url
        }).catch(res => {
          console.log(res)
        })

      }
    }
  }
</script>
